import { communitAPI } from ".";

export async function getTokenList(userId: Moim.Id) {
  return (
    await communitAPI.request<
      Promise<{
        data: Moim.NFT.INftToken[];
      }>
    >({
      method: "GET",
      url: `/nfts/tokens?userId=${userId}`,
    })
  ).data;
}

export async function getItemsDetail(itemIds: Moim.Id[]) {
  return (
    await communitAPI.request<
      Promise<{
        data: Moim.NFT.INftDetail[];
      }>
    >({
      method: "POST",
      url: `/nfts/_batch`,
      data: { ids: itemIds },
    })
  ).data;
}

export async function getContractsDetail(contractIds: Moim.Id[]) {
  return (
    await communitAPI.request<
      Promise<{
        data: Moim.NFT.IContract[];
      }>
    >({
      method: "POST",
      url: `/nfts/contracts/_batch`,
      data: { ids: contractIds },
    })
  ).data;
}
